import KillTeamDatacardGenerator from "./KillTeamDatacardGenerator";

function App() {
  return <KillTeamDatacardGenerator />;
}

export default App;